// extracted by mini-css-extract-plugin
export default {"overWriteContent":"src-pages-SalesChannelContentEditor-SalesChannelEditorShoppingCartPage-FeaturedProducts-css__overWriteContent--b6HvT"};